import { render, staticRenderFns } from "./SubscribeHero.vue?vue&type=template&id=1f044291&scoped=true&"
import script from "./SubscribeHero.vue?vue&type=script&lang=js&"
export * from "./SubscribeHero.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeHero.vue?vue&type=style&index=0&id=1f044291&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f044291",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribeStats: require('/opt/render/project/src/channels2022/src/components/subscribe/SubscribeStats.vue').default,SubscribePrice: require('/opt/render/project/src/channels2022/src/components/subscribe/price/SubscribePrice.vue').default,SubscribeHeroBanner: require('/opt/render/project/src/channels2022/src/components/subscribe/SubscribeHeroBanner.vue').default})
